import store from '@/store'

export function guardRoutes(to, from, next) {
  // guard routes that requires users to be logged out
  if (to.meta.requiresGuest) {
    if (store.getters['auth/isLoggedIn']) {
      next({
        name: 'frontend'
      })
    } else {
      next()
    }

    // guard routes that requires users to be logged in
  } else if (to.meta.requiresPermission) {
    if (store.getters['auth/isLoggedIn']) {
      // check if user has permission to access route
      if (
        store.state.auth.currentUser.permissions.indexOf(
          to.meta.requiresPermission
        ) > -1
      ) {
        next()
      } else {
        next({
          name: from.name || 'frontend'
        })
      }
    } else {
      next({
        name: 'login',
        query: {
          redirect: to.name
        }
      })
    }
  } else {
    next()
  }
}
